import { render, staticRenderFns } from "./MatchMakingTest.vue?vue&type=template&id=32b47a7c&scoped=true&"
import script from "./MatchMakingTest.vue?vue&type=script&lang=js&"
export * from "./MatchMakingTest.vue?vue&type=script&lang=js&"
import style0 from "./MatchMakingTest.vue?vue&type=style&index=0&id=32b47a7c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b47a7c",
  null
  
)

export default component.exports